// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  debug: true,
  log: {
    auth: false,
    store: false,
  },

  smartadmin: {
    api: null,
    db: 'smartadmin-angular'
  },
  cookieDomain:".io-netgate.net",
  checkCookie:"expireCookie",
  instanceCookie:"instanceCookie",
  loginCookie: "loginCookie",
  userRightsCookie: "userRightsCookie",
  tokenExpireTime:"cookieCreatedTime",
  userInfo: "userInfo",
  API_URL:'https://dfh56.api.io-netgate.net/api/v1/',
  domain:'.io-netgate.net',
  languageCookie:'languageCookie',
  styleCookie:'styleCookie',
  cookieConsent: "cookieConsent",
  NETGATE_URL: 'https://portal.netgate.io-procurement.com/',
  SUB_DOMAIN:".io-netgate.net",
  SESSION_EXPIRY : 30000 * 60 * 30,
  color: 'colorChangeTest'
};

